export const LIST_CORPORATE = 'src/Admin/userAccessManagement/LIST_CORPORATE';
export const LIST_CORPORATE_SUCCESS = 'src/Admin/userAccessManagement/action/LIST_CORPORATE_Success';
export const LIST_CORPORATE_FAILURE = 'src/Admin/userAccessManagement/action/LIST_CORPORATE_Failure';
export const GET_ANALYSTS_LIST = 'src/Admin/userAccessManagement/GET_ANALYSTS_LIST';
export const GET_ANALYSTS_LIST_SUCCESS = 'src/Admin/userAccessManagement/action/GET_ANALYSTS_LIST_SUCCESS';
export const GET_ANALYSTS_LIST_FAILURE = 'src/Admin/userAccessManagement/action/GET_ANALYSTS_LIST_FAILURE';
export const USER_SELECTED_CORPORATES = 'src/Admin/userAccessManagement/USER_SELECTED_CORPORATES';
export const USER_SELECTED_CORPORATES_SUCCESS = 'src/Admin/userAccessManagement/action/USER_SELECTED_CORPORATES_SUCCESS';
export const USER_SELECTED_CORPORATES_FAILURE = 'src/Admin/userAccessManagement/action/USER_SELECTED_CORPORATES_FAILURE';
export const FETCH_USER_CORPORATES = 'src/Admin/userAccessManagement/FETCH_USER_CORPORATES';
export const FETCH_USER_CORPORATES_SUCCESS = 'src/Admin/userAccessManagement/action/FETCH_USER_CORPORATES_SUCCESS';
export const FETCH_USER_CORPORATES_FAILURE = 'src/Admin/userAccessManagement/action/FETCH_USER_CORPORATES_FAILURE';

export const getAnalystsList =()=>{
    return{
        type:GET_ANALYSTS_LIST
    }
}

export const getAnalystsListSuccess =(data)=>{
    return{
        type:GET_ANALYSTS_LIST_SUCCESS,
        data
    }
}

export const getAnalystsListFailure =(data)=>{
    return{
        type:GET_ANALYSTS_LIST_FAILURE,
        data
    }
}

export const listCorporate = () => {
    return {
        type: LIST_CORPORATE,
    }
}

export const listCorporateSuccess = (data) => {
    return {
        type: LIST_CORPORATE_SUCCESS,
        data
    }
}

export const listCorporateFailure = (error) => {
    return {
        type: LIST_CORPORATE_FAILURE,
        error
    }
}

export const userSelectedCorporates = (data) => {
    return {
        type: USER_SELECTED_CORPORATES,
        data
    }
}

export const userSelectedCorporatesSuccess = (data) => {
    return {
        type: USER_SELECTED_CORPORATES_SUCCESS,
        data
    }
}

export const userSelectedCorporatesFailure = (error) => {
    return {
        type: USER_SELECTED_CORPORATES_FAILURE,
        error
    }
}

export const fetchUserCorporates = (data) => {
    return {
        type: FETCH_USER_CORPORATES,
        data
    }
}

export const fetchUserCorporatesSuccess = (data) => {
    return {
        type: FETCH_USER_CORPORATES_SUCCESS,
        data
    }
}

export const fetchUserCorporatesFailure = (error) => {
    return {
        type: FETCH_USER_CORPORATES_FAILURE,
        error
    }
}